// extracted by mini-css-extract-plugin
export default {"container":"TutorialScreen_container__i58Xi"};